import {
  Generic,
  Place,
} from 'src/api/models'

import { Handler, HandlerInput } from './base'
import { Action, ApplyScan } from './interface'

interface AssignMentHandlerInput extends HandlerInput {
  obj: Generic
}

export class AssignmentHandler extends Handler {
  obj: Generic
  assignment?: Generic

  constructor(props: AssignMentHandlerInput) {
    super(props)
    this.obj = props.obj
  }

  apply = ({ scanned, context, local }: ApplyScan): [Action, any | undefined] => {
    switch (scanned.object.type) {
      case Place.type: {
        if (this.assignment === scanned) {
          return [
            Action.Move,
            { source: scanned.object.guid, items: [{ item: this.obj.object.guid, num: 1 }], destination: scanned.object.guid },
          ]
        } else {
          this.assignment = scanned
        }
      }
    }
    return [Action.Invalid, undefined]
  }

  getContext = () => {
    return { activity: 'assigning', obj: this.obj.object.guid }
  }
}
